import {
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr
} from '@chakra-ui/react'
import { CustomLinkOverlay, Ellipsis, EmptyTablePlaceholder, TableSkeleton } from 'BrokerTsLib/src/components'
import { flexGroupListContext } from 'BrokerTsLib/src/context'
import type { FlexGroupGridItem } from 'BrokerTsLib/src/dtos'
import type { ColumnDefinition } from 'BrokerTsLib/src/interfaces/columnsDefinition'
import { useContext } from 'react'

import { FlexGroupLink, ValidityBadge } from '@/components'

import { FlexGroupTypeBadge } from './FlexGroupTypeBadge'

export const FlexGroupListNameColumn: ColumnDefinition<FlexGroupGridItem>
    = { key: 'name', name: 'Název', cellExpr: (item) => <FlexGroupLink sx={{ color: 'primary.500', fontWeight: 'medium' }} flexGroupId={item.id} name={item.name} /> }


export const FlexGroupListDescriptionColumn: ColumnDefinition<FlexGroupGridItem>
    = {
      key: 'description', name: 'Popis', cellExpr: (item) =>
        <Ellipsis>{item.description}</Ellipsis>
    }

export const FlexGroupListTypeColumn: ColumnDefinition<FlexGroupGridItem> = {
  key: 'type',
  name: 'Typ',
  cellExpr: (item) => <FlexGroupTypeBadge type={item.type} />
}

export const FlexGroupListValidColumn: ColumnDefinition<FlexGroupGridItem>
    = { key: 'valid', name: '', cellExpr: (item) => <ValidityBadge valid={item.valid} />, cellProps: { p: 1 } }

export const FlexGroupListDefaultColumns: ColumnDefinition<FlexGroupGridItem>[] = [
  FlexGroupListNameColumn,
  FlexGroupListDescriptionColumn,
  FlexGroupListTypeColumn,
  FlexGroupListValidColumn
]

export function FlexGroupList<TGridItem extends FlexGroupGridItem>({
  flexGroups,
  columns = FlexGroupListDefaultColumns as ColumnDefinition<TGridItem>[]
}: {
  flexGroups: Array<TGridItem>
  columns?: ColumnDefinition<TGridItem>[]
}) {
  const { pageSize, loading } = useContext(flexGroupListContext)

  return <Table variant="simple">
    <Thead>
      <Tr>
        {columns && columns.map(column => (<Th key={column.key} _empty={{ w: 0, p: 0 }} {...column.headerCellProps}>{column.name}</Th>))}
      </Tr>
    </Thead>
    <Tbody>
      <TableSkeleton rowsCount={pageSize} colSpan={columns.length} isLoaded={!loading} >
        <EmptyTablePlaceholder text='Žádné flexibilní skupiny k zobrazení' colSpan={columns.length}>{
          flexGroups.map(flexGroup => {
            return (
              <CustomLinkOverlay to={`/flex-group/${flexGroup.id}`} as={Tr} key={flexGroup.id}>
                {columns && columns.map(column =>
                  <Td key={column.key} _empty={{ p: 0 }} {...column.cellProps}>
                    {column.cellExpr(flexGroup) || ''}
                  </Td>
                )}
              </CustomLinkOverlay>
            )
          })}
        </EmptyTablePlaceholder>
      </TableSkeleton>
    </Tbody>
  </Table>
}
